import {Grid} from "@mui/material";
import {styled} from "@mui/material/styles";

export const CheckBoxFlex = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const CheckBoxFullWidth = styled(Grid)(() => ({
  flex: 1
}));
